<script setup>
import QuotationTable from '@frontJs/components/tables/projectManagement/apikom/QuotationTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { useRoute } from '@js/utils/route';
import { h, onMounted, ref } from 'vue';

const { route } = useRoute();

const loading = ref(true);

const allCount = ref([]);

function updateData() {
    loading.value = true;

    const statutes = [
        'ongoing',
        'won',
        'to_invoice',
        'invoiced',
        'partially_invoiced',
        'closed',
        'lost',
    ];

    const promises = statutes.map((status) => {
        return new Promise((resolve, reject) => {
            let url = route(
                'front.projectManagement.apikom.postQuotationCount',
            );

            let postData = {
                status: status,
            };

            let config = {};

            axios
                .post(url, postData, config)
                .then((response) => {
                    resolve(response.data.count);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        });
    });

    Promise.all(promises)
        .then((counts) => {
            allCount.value = counts;
        })
        .catch((error) => {
            console.log(error);
        })
        .finally(() => {
            loading.value = false;
        });
}

onMounted(() => {
    updateData();
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Devis - Apikom - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Apikom - Devis </PageTitle>

    <TabLayout
        :tabs="{
            ongoing: {
                title: 'En cours',
                total: allCount[0],
                content: h(QuotationTable, {
                    ongoing: true,
                }),
            },
            won: {
                title: 'Gagné',
                total: allCount[1],
                content: h(QuotationTable, {
                    won: true,
                }),
            },
            toInvoice: {
                title: 'À facturer',
                total: allCount[2],
                content: h(QuotationTable, {
                    toInvoice: true,
                }),
            },
            invoiced: {
                title: 'Facturé',
                total: allCount[3],
                content: h(QuotationTable, {
                    invoiced: true,
                }),
            },
            partiallyInvoiced: {
                title: 'Partiellement facturé',
                total: allCount[4],
                content: h(QuotationTable, {
                    partiallyInvoiced: true,
                }),
            },
            closed: {
                title: 'Fermé',
                total: allCount[5],
                content: h(QuotationTable, {
                    closed: true,
                }),
            },
            lost: {
                title: 'Perdu',
                total: allCount[6],
                content: h(QuotationTable, {
                    lost: true,
                }),
            },
        }"
        :loading="loading"
    />
</template>
